function resolvePreviewApiHost(): string {
  if (typeof window !== 'undefined' && window.location?.hostname) {
    const match = /^pr-(\d+)\.preview\.durvey\.org$/i.exec(window.location.hostname);
    if (match) {
      return `pr-${match[1]}.preview.api.durvey.org`;
    }
  }
  return 'api-staging.durvey.org';
}

const previewApiHost = resolvePreviewApiHost();

export const environment = {
  production: false,
  stripe: {
    publishableKey: 'pk_test_51RoQEOJpE3Qi5nO8bgvZhomlzwFHZhO5OenfDsKlPa3gSj59RiabgxbKOBd2oAOausQwL8xnW1i2Xnb3BN5IR6Au003kL6ZT3Q'
  },
  sentry: {
    dsn: '',
    enabled: false
  },
  apiUrl: `https://${previewApiHost}`,
  websocketUrl: `wss://${previewApiHost}/ws`,
  debug: false,
  apiTimeoutMs: 30000,
  hashidsSalt: 'id-salt-12345',
  features: {
    enableAnalytics: false,
    enableDebugTools: false,
    enableMockData: false
  },
  auth: {
    tokenExpiryHours: 12,
    refreshTokenEnabled: true
  },
  logging: {
    level: 'error',
    enableConsole: false,
    enableRemote: false
  },
  recaptchaSiteKey: '6Ley9T0sAAAAAE4VBBhpr_6BzmXvKzJaX26tTfPs',
  // Single host serves both creator and participant routes on PR previews.
  creatorUrl: '',
  participantUrl: '',
  // The admin dashboard on its own site and API host (docs/plans/CEO_HOST_PLAN.md). Empty = no split:
  // /admin stays on this host and talks to apiUrl.
  adminUrl: '',
  adminApiUrl: '',
  adminWebsocketUrl: '',
  // The partner portal (docs/plans/PARTNER_PROGRAM_PLAN.md): at /partner on the preview host.
  partnerUrl: ''
};
